import { lazy } from "react";
import { Route } from "react-router-dom";
import { AdminLayout } from "../components/layout/AppLayout";

/**
 * Groupe de routes ADMIN (12) — SITE_SPEC §3.4.
 * Montées sous `path="admin"` avec <AdminLayout> qui applique la garde de rôle (STAFF+ ;
 * accès refusé sinon). À insérer sous <AppLayout>.
 */

const AdminDashboard = lazy(() => import("../pages/admin/AdminDashboard"));
const Joueurs = lazy(() => import("../pages/admin/Joueurs"));
const Grades = lazy(() => import("../pages/admin/Grades"));
const AdminEconomie = lazy(() => import("../pages/admin/AdminEconomie"));
const AdminShop = lazy(() => import("../pages/admin/AdminShop"));
const Items = lazy(() => import("../pages/admin/Items"));
const Mobs = lazy(() => import("../pages/admin/Mobs"));
const Config = lazy(() => import("../pages/admin/Config"));
const Deploiement = lazy(() => import("../pages/admin/Deploiement"));
const Contenu = lazy(() => import("../pages/admin/Contenu"));
const Moderation = lazy(() => import("../pages/admin/Moderation"));
const AdminForum = lazy(() => import("../pages/admin/AdminForum"));
const AdminSignalements = lazy(() => import("../pages/admin/AdminSignalements"));
const AdminSuggestions = lazy(() => import("../pages/admin/AdminSuggestions"));
const Broadcast = lazy(() => import("../pages/admin/Broadcast"));
const Perf = lazy(() => import("../pages/admin/Perf"));
const Logs = lazy(() => import("../pages/admin/Logs"));
const MasterHistorique = lazy(() => import("../pages/admin/MasterHistorique"));
const AdminCarte = lazy(() => import("../pages/admin/AdminCarte"));
const Reglages = lazy(() => import("../pages/admin/Reglages"));
const WipePlayers = lazy(() => import("../pages/admin/WipePlayers"));
const BattlePass = lazy(() => import("../pages/admin/BattlePass"));
const Npcs = lazy(() => import("../pages/admin/Npcs"));
const DonjonSchematics = lazy(() => import("../pages/admin/DonjonSchematics"));

export const adminRoutes = (
  <Route path="admin" element={<AdminLayout />}>
    <Route index element={<AdminDashboard />} />
    <Route path="joueurs" element={<Joueurs />} />
    <Route path="grades" element={<Grades />} />
    <Route path="economie" element={<AdminEconomie />} />
    <Route path="boutique" element={<AdminShop />} />
    <Route path="items" element={<Items />} />
    <Route path="mobs" element={<Mobs />} />
    <Route path="config" element={<Config />} />
    <Route path="deploiement" element={<Deploiement />} />
    <Route path="contenu" element={<Contenu />} />
    <Route path="moderation" element={<Moderation />} />
    <Route path="forum" element={<AdminForum />} />
    <Route path="signalements" element={<AdminSignalements />} />
    <Route path="suggestions" element={<AdminSuggestions />} />
    <Route path="broadcast" element={<Broadcast />} />
    <Route path="perf" element={<Perf />} />
    <Route path="logs" element={<Logs />} />
    <Route path="historique-master" element={<MasterHistorique />} />
    <Route path="carte" element={<AdminCarte />} />
    <Route path="reglages" element={<Reglages />} />
    <Route path="wipe" element={<WipePlayers />} />
    <Route path="battlepass" element={<BattlePass />} />
    <Route path="npcs" element={<Npcs />} />
    <Route path="donjon-schematics" element={<DonjonSchematics />} />
  </Route>
);
